import React from 'react';
import videojs from 'video.js';
import {handleError} from '../../../Utils/VideoUtils';

//VIDEOJS IMPORTS
import 'videojs-hotkeys';
import 'videojs-awesome-watermark';
import 'video.js/dist/video-js.css';
import 'videojs-hls-quality-selector';
import 'videojs-contrib-quality-levels';
import 'videojs-awesome-watermark/dist/videojs-awesome-watermark.css';
import '../Summary/Summary.styl';
// import '@silvermine/videojs-airplay/dist/silvermine-videojs-airplay.css';
// import 'videojs-hls-quality-selector/dist/videojs-hls-quality-selector.css';
// import '@silvermine/videojs-chromecast/dist/silvermine-videojs-chromecast.css';

// require('@silvermine/videojs-chromecast')(videojs);
// require('@silvermine/videojs-airplay')(videojs);

const VideoJS = (props: any) => {
  const videoRef = React.useRef<HTMLDivElement>(null);
  const playerRef = React.useRef<any>();

  const {options, onReady} = props;

  React.useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js');
      videoElement.setAttribute('id', 'player-' + options.code);

      // videoElement.classList.add('vjs-big-play-centered');
      videoRef.current?.appendChild(videoElement);

      // ((videojs as any).Vhs as any).xhr.afterRequest = function (currentOptions: any) {
      //   if (currentOptions.uri.toString().indexOf('https://video.gumlet.io') > -1
      //   || (currentOptions.uri).toString().indexOf('https://hosting.smartplayer.ai/videos') > -1) {
      //     console.log('currentOptions', currentOptions);
      //     return currentOptions;
      //   }

      //   return currentOptions;
      // };

      const isIos = () => {
        if (typeof window === `undefined` || typeof navigator === `undefined`) return false;

        return /iPhone/i.test(navigator.userAgent || navigator.vendor || (((window as any)?.opera as any) && ((window as any)?.opera as any).toString() === `[object Opera]`));
      };

      ((videojs as any).Vhs as any).xhr.beforeRequest = function (currentOptions: any) {
        if (!currentOptions.headers) {
          currentOptions.headers = {};
        }

        if ((currentOptions.uri).toString().indexOf('https://hosting.smartplayer.ai/videos') > -1 && isIos()) {
          currentOptions.uri = (currentOptions.uri).toString().replace('https://hosting.smartplayer.ai/videos', 'https://video.gumlet.io');
          return currentOptions;
        }

        if ((currentOptions.uri).toString().indexOf('https://video.gumlet.io') > -1
         || (currentOptions.uri).toString().indexOf('https://hosting.smartplayer.ai/videos') > -1) {
          return currentOptions;
        }

        if ((currentOptions.uri).toString().indexOf('https://stream.smartplayer.ai') > -1) {
          return currentOptions;
        }

        if ((currentOptions.uri).toString().indexOf('https://stream.scaleup.com.br/player/v1/playlists') !== -1) {
          currentOptions.headers = {
            Authorization: 'Bearer ' + options.authorization
          };

          return;
        }

        if ((currentOptions.uri).toString().indexOf('.ts') === -1
         && (currentOptions.uri).toString().indexOf('.m3u8') === -1
         && (currentOptions.uri).toString().indexOf('.mp4') === -1
         && (currentOptions.uri).toString().indexOf('.m4s') === -1) {
          return currentOptions;
        }

        if ((currentOptions.uri).toString().indexOf('?URLPrefix') > -1) {
          return currentOptions;
        }

        const isSummary = (currentOptions?.uri || '').indexOf(options.mediaCode) === -1;

        const hasKey = (isSummary ? options.summaryVideoCdnKey : options.cdnKey);

        if (!(currentOptions?.uri || '').toString().includes('?Policy=') && hasKey) {
          currentOptions.uri = currentOptions?.uri + '?' + (isSummary ? options.summaryVideoCdnKey : options.cdnKey);
        }

        return currentOptions;
      };

      const player = (playerRef.current = videojs(
        '#player-' + options.code,
        {
          ...options,
          autoplay: options.summary ? options.summary : options.autoplay,
          html5: {
            vhs: {
              enableWorker: true,
              overrideNative: true,
              nativeAudioTracks: false,
              nativeVideoTracks: false,
              smoothQualityChange: true,
              limitRenditionByPlayerDimensions: false,
              useDevicePixelRatio: true,
              enableLowInitialPlaylist: true,
              useNetworkInformationApi: true,
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false,
          },
        },
        () => {
          player.el().classList.remove('videojs--loading');
          onReady && onReady(player);
        },
      ));

      player.playsinline(true);
      // if (!options.summary && options.transcription) {
      //   player.addRemoteTextTrack({ src: options.transcription }, false);
      // }

      // try {
      //   playerRef.current.airplay();
      // } catch (e) {
      //   console.error(e);
      // }

      // try {
      //   playerRef.current.chromecast();
      // } catch (e) {
      //   console.error(e);
      // }
    } else {
      const player = playerRef.current;

      // if (!options.summary && options.transcription) {
      //   player.addRemoteTextTrack({ src: options.transcription }, false);
      // }

      player.autoplay(options.summary ? options.summary : options.autoplay);

      player.src(options.sources);
    }
  }, [options, options?.summary, videoRef, onReady]);

  React.useEffect(() => {
    const player = playerRef.current;

    window.onbeforeunload = () => {
      player.dispose();

      if (playerRef.current.player_) {
        console.log('has player child');
        playerRef.current.player_ = null;
      }

      playerRef.current = null;

      console.log('Killall smartplayer');
    };

    player.on('error', () => handleError(player.error_.code, player.error_.message, player));

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default VideoJS;
